const authorFromScratch = {
  topicId: "nualang.author-from-scratch.0.0.1",
  topicName: "Crea il tuo",
  description: "",
  difficulty: "ALL",
  learnLang: "italian",
};

export default authorFromScratch;
